import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import AIAgents from '../components/AIAgents';
import Security from '../components/Security';
import UseCases from '../components/UseCases';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { Toaster } from '../components/ui/sonner';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      <Hero />
      <AIAgents />
      <Security />
      <UseCases />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
};

export default LandingPage;
